import { Grid } from '@mui/material'
import { openNewWindow } from 'features/common/utils/navigationUtils'
import { Map } from 'features/maps/types'
import MapCard from 'features/maps/ui/MapCard/MapCard'
import { getMapUrlForUser } from 'features/maps/utils'
import { useCurrentUser } from 'features/users/hooks/userQueryHooks'

export function HomeDynamicMaps({ maps }: { maps: Map[] }) {
  const me = useCurrentUser()

  const handleMapClick = (map: Map) => {
    const url = getMapUrlForUser(map, me)
    if (url) {
      openNewWindow(url)
    }
  }

  return (
    <>
      {maps.map((map) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={map.id}>
            <MapCard onClick={() => handleMapClick(map)} map={map} />
          </Grid>
        )
      })}
    </>
  )
}

export default HomeDynamicMaps
